<template>
<div style="text-align: left;">
  <h2>Article Submission</h2>

  <div>
    <label for="title">Title: </label><br>
    <input type="text" v-model="title" placeholder="Title" required />
  </div>

  <div class="w3-margin-bottom">
    <label for="abstract">Abstract: </label><br>
    <textarea type="text" v-model="abst" class="w3-input w3-border" placeholder="Abstract" required />
  </div>

  <div class="w3-margin-bottom">
    <input type="file" @change="onFileChange" />
    <button @click="uploadFile" :disabled="!file || loading" class="w3-button w3-blue">Upload</button>

    <!-- Display Result and GPG Signature Form -->
    <div v-if="fileUrl" class="result w3-margin-top">
      <h3>Article Compilation Succeeded</h3>
      <p>CID: {{ pdfCid }}</p>
      <p>Your file has been processed and <i>NOW PUBLIC</i> on the IPFS network, but article review process is not initiated yet.<br>To finalize your submission and notify our reviewers:
      </p>
      <ol>
        <li> Download the processed PDF below. </li>
        <li> Sign it with GPG. If you're not familiar with GPG, you can use Kleopatra Graphic Interface, which is included in <a href="https://www.gpg4win.org/">Gpg4win</a>. Or if you're using macOS, use <a href="https://gpgtools.org/">GPG Suite</a>.</li>
        <li> Submit the signature using the field below!</li>
      </ol>

      <p>
        <a :href="fileUrl" :download="downloadedFileName" target="_blank">{{ downloadedFileName }}</a>
      </p>

      <textarea v-model="gpgSignature" placeholder="Enter GPG Signature" class="w3-input w3-border"></textarea><br>
      <button @click="submitSignature" :disabled="!gpgSignature || loading" class="w3-button w3-green">Submit Signature</button>
    </div>
  </div>

</div>
</template>

<script>
import config from '../config';
  
export default {
  setup() {
    return {
      config
    };
  },
  data() {
    return {
      file: null,
      result: null,
      gpgSignature: "",
      loading: false,
      pdfCid: '',
    };
  },
  methods: {
    onFileChange(event) {
      this.file = event.target.files[0];
    },
    async uploadFile() {
      if (!this.file) return;

      const formData = new FormData();
      formData.append("title", this.title);
      formData.append("abstract", this.abst);
      formData.append("articleFile", this.file);

      this.loading = true;
      const token = sessionStorage.getItem("jwt");

      try {
        const response = await fetch(`${ config.apiBaseUrl }/articles/submit`, {
          method: "POST",
          credentials: 'include',
          headers: {
            "Authorization": `Bearer ${token}`, // Include JWT in the Authorization header
          },
          body: formData,
        });

        if (response.ok) {
            // Get the file name from the content-disposition header
          const contentDisposition = response.headers.get('content-disposition');
          const fileName = contentDisposition
            ? contentDisposition.split('filename=')[1].replace(/['"]/g, '')
            : 'Submission PDF';

          this.pdfCid = response.headers.get('Content-Cid');
          console.log('Content-Cid: ', this.pdfCid);
          this.downloadedFileName = fileName;

          // Convert response to a blob
          const blob = await response.blob();

          // Create a URL for the file
          this.fileUrl = window.URL.createObjectURL(blob);

          // Store the result blob to be signed
          this.result = blob;
        } else {
          alert("File upload failed.");
        }
      } catch (error) {
        console.error("Error uploading file:", error);
        alert("An error occurred.");
      } finally {
        this.loading = false;
      }
    },
    async submitSignature() {
      if (!this.gpgSignature) return;

      this.loading = true;
      const token = sessionStorage.getItem("jwt");

      try {
        const response = await fetch(`${ config.apiBaseUrl }/articles/submit/sig`, {
          method: "POST",
          headers: {
            "Authorization": `Bearer ${token}`, // Include JWT in the Authorization header
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            // result: this.result,
            signature: this.gpgSignature,
            cid: this.pdfCid
          }),
        });

        if (response.ok) {
          alert("Signature submitted successfully.");
          this.$router.push({
            name: "Profile",
            query: { username: sessionStorage.getItem('username') }
          });
        } else {
          alert("Failed to submit signature.");
        }
      } catch (error) {
        console.error("Error submitting signature:", error);
        alert("An error occurred.");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

